import Vue from "vue";
import App from "./App.vue";

import "./mixin/globalMixins";

import VueRouter from "vue-router";
import common from "./assets/js/common";
import VueMeta from "vue-meta";
import VueYoutube from "vue-youtube";
import VueKakaoSdk from "vue-kakao-sdk";
import "./registerServiceWorker";

const apiKey = process.env.VUE_APP_KAKAO_API_KEY;
Vue.use(VueKakaoSdk, { apiKey }); // apiKey 를 반드시
Vue.use(VueYoutube);

Vue.use(VueRouter);
Vue.use(VueMeta);

import Vuex from "vuex";
Vue.use(Vuex);
Vue.use(common);
import VueHead from "vue-head";
Vue.use(VueHead);

// import Paginate from "vuejs-paginate";
// Vue.use(Paginate);

/* Router & Store */
import store from "./store";
import router from "./router";

// cdn
import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

//swiper impoert and autoplay, pageination impoert
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
import "swiper/swiper-bundle.css";

import vuetify from "./plugins/vuetify";
import page from "./plugins/page";
window.$ = window.jQuery = require("jquery");

Vue.config.productionTip = false;

export const eventBus = new Vue({
  vuetify,

  methods: {
    imageSelect(val) {
      this.$emit("imageSelect", val);
    },
    makeTabletTxt(val) {
      this.$emit("makeTabletTxt", val);
    },
    tabletInit() {
      this.$emit("tabletInit");
    },
    tabletHorizontalTxt(val) {
      this.$emit("tabletHorizontalTxt", val);
    },
    tabletDataInit(val) {
      this.$emit("tabletDataInit", val);
    },
    tabletMainDataInit(val) {
      this.$emit("tabletMainDataInit", val);
    }
  }
});

new Vue({
  store,
  router,
  vuetify,
  page,
  render: h => h(App)
}).$mount("#app");
